// Pre-launch portfolio address (EPD-10101). The edge 301s /p2/<slug> to the
// portfolio's current address (apps/web/worker.ts); this redirect covers the
// app without the edge worker in front (local dev). Media Kit links written
// before launch still point here (EPD-12223).

import { redirectToPortfolioAddress } from "@/lib/portfolio/public-page";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/p2/$profileSlug")({
  beforeLoad: ({ params, location }) =>
    redirectToPortfolioAddress({ slug: params.profileSlug, location }),
});
